// import React, { useEffect, useState } from "react";
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine, Area, AreaChart } from "recharts";

// const GOOGLE_SHEET_ID = "1gXp7KngcraVZXc2T15hSTijyK2TJplWU5mDC2IZcxgE";
// const SHEET_URL = `https://opensheet.elk.sh/${GOOGLE_SHEET_ID}/Sheet1`;

// // Flood control level definitions (in meters)
// const FLOOD_LEVELS = {
//   SAFE: { max: 50, color: "#22c55e", label: "सुरक्षित स्तर" },
//   CAUTION: { max: 100, color: "#eab308", label: "सावधान स्तर" },
//   WARNING: { max: 200, color: "#f97316", label: "चेतावणी स्तर" },
//   DANGER: { max: 500, color: "#ef4444", label: "धोकादायक स्तर" },
//   CRITICAL: { max: Infinity, color: "#991b1b", label: "अत्यंत धोकादायक" }
// };

// const WaterLevelMonitoring = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedLocation, setSelectedLocation] = useState(null);

//   useEffect(() => {
//     setLoading(true);
//     fetch(SHEET_URL)
//       .then((res) => res.json())
//       .then((raw) => {
//         const parsed = raw
//           .filter(row => row["device_id"] && row["Water level"]) // Filter out empty rows
//           .map((row, index) => ({
//             id: index,
//             deviceId: row["device_id"] || "Unknown",
//             location: row["location"] || "Unknown",
//             level: parseFloat(row["Water level"] || 0),
//             time: row["time"] || "",
//             discharge: parseFloat(row["discharge"] || 0),
//             volume: parseFloat(row["volume"] || 0),
//             latitude: parseFloat(row["latitude"] || 0),
//             longitude: parseFloat(row["longitude"] || 0),
//           }))
//           .sort((a, b) => new Date(a.time) - new Date(b.time)); // Sort by time

//         setData(parsed);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("❌ Error loading sheet:", err);
//         setLoading(false);
//       });
//   }, []);

//   const getFloodLevel = (level) => {
//     if (level <= FLOOD_LEVELS.SAFE.max) return FLOOD_LEVELS.SAFE;
//     if (level <= FLOOD_LEVELS.CAUTION.max) return FLOOD_LEVELS.CAUTION;
//     if (level <= FLOOD_LEVELS.WARNING.max) return FLOOD_LEVELS.WARNING;
//     if (level <= FLOOD_LEVELS.DANGER.max) return FLOOD_LEVELS.DANGER;
//     return FLOOD_LEVELS.CRITICAL;
//   };

//   const locationList = [...new Set(data.map((row) => row.location))];

//   let filteredData = data;
//   if (selectedLocation) {
//     filteredData = filteredData.filter((row) => row.location === selectedLocation);
//   }

//   // Prepare chart data with flood level indicators
//   const chartData = filteredData.map(item => ({
//     ...item,
//     floodLevel: getFloodLevel(item.level).label,
//     timeFormatted: new Date(item.time).toLocaleString('hi-IN', {
//       dateStyle: 'short',
//       timeStyle: 'short'
//     })
//   }));

//   // Custom tooltip
//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       const floodInfo = getFloodLevel(data.level);
      
//       return (
//         <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
//           <p className="font-semibold">{`समय: ${data.timeFormatted}`}</p>
//           <p className="text-blue-600">{`पातळी: ${data.level} मीटर`}</p>
//           <p className="text-gray-600">{`स्थान: ${data.location}`}</p>
//           <p style={{ color: floodInfo.color }} className="font-semibold">
//             {`स्तर: ${floodInfo.label}`}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-xl">डेटा लोड हो रहा है... ⏳</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h1 className="text-3xl font-bold mb-6 text-center text-blue-800">
//         💧 पाण्याची पातळी मॉनिटरिंग सिस्टीम
//       </h1>

//       {/* Filters */}
//       <div className="bg-white p-4 rounded-lg shadow-md mb-6">
//         <div className="grid grid-cols-1 gap-4">
//           <div>
//             <label className="block font-semibold mb-2">📍 स्थान निवडा:</label>
//             <select
//               value={selectedLocation || ""}
//               onChange={(e) => setSelectedLocation(e.target.value || null)}
//               className="w-full border p-2 rounded-md"
//             >
//               <option value="">-- सर्व स्थाने --</option>
//               {locationList.map((location) => (
//                 <option key={location} value={location}>
//                   {location}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Flood Level Legend */}
//       <div className="bg-white p-4 rounded-lg shadow-md mb-6">
//         <h3 className="text-lg font-semibold mb-3">🚨 पूर नियंत्रण स्तर</h3>
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
//           {Object.values(FLOOD_LEVELS).slice(0, -1).map((level, index) => (
//             <div key={index} className="flex items-center space-x-2">
//               <div 
//                 className="w-4 h-4 rounded"
//                 style={{ backgroundColor: level.color }}
//               ></div>
//               <span className="text-sm">{level.label}</span>
//               <span className="text-xs text-gray-500">
//                 (≤{level.max}m)
//               </span>
//             </div>
//           ))}
//           <div className="flex items-center space-x-2">
//             <div 
//               className="w-4 h-4 rounded"
//               style={{ backgroundColor: FLOOD_LEVELS.CRITICAL.color }}
//             ></div>
//             <span className="text-sm">{FLOOD_LEVELS.CRITICAL.label}</span>
//             <span className="text-xs text-gray-500">(>500m)</span>
//           </div>
//         </div>
//       </div>

//       {/* Main Chart */}
//       <div className="bg-white p-6 rounded-lg shadow-md mb-6">
//         <h3 className="text-xl font-semibold mb-4">📈 पाण्याची पातळी ट्रेंड</h3>
//         {chartData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis 
//                 dataKey="timeFormatted" 
//                 tick={{ fontSize: 12 }}
//                 interval="preserveStartEnd"
//               />
//               <YAxis 
//                 label={{ value: "पातळी (मीटर)", angle: -90, position: "insideLeft" }}
//               />
              
//               {/* Reference lines for flood levels */}
//               <ReferenceLine y={50} stroke={FLOOD_LEVELS.SAFE.color} strokeDasharray="8 4" />
//               <ReferenceLine y={100} stroke={FLOOD_LEVELS.CAUTION.color} strokeDasharray="8 4" />
//               <ReferenceLine y={200} stroke={FLOOD_LEVELS.WARNING.color} strokeDasharray="8 4" />
//               <ReferenceLine y={500} stroke={FLOOD_LEVELS.DANGER.color} strokeDasharray="8 4" />
              
//               <Tooltip content={<CustomTooltip />} />
//               <Legend />
              
//               <Line 
//                 type="monotone" 
//                 dataKey="level" 
//                 stroke="#2563eb" 
//                 strokeWidth={3}
//                 dot={{ fill: "#2563eb", strokeWidth: 2, r: 4 }}
//                 name="पाण्याची पातळी (मीटर)"
//               />
//             </LineChart>
//           </ResponsiveContainer>
//         ) : (
//           <div className="text-center text-gray-500 py-8">
//             कोणताही डेटा उपलब्ध नाही
//           </div>
//         )}
//       </div>

//       {/* Area Chart for Better Visualization */}
//       <div className="bg-white p-6 rounded-lg shadow-md mb-6">
//         <h3 className="text-xl font-semibold mb-4">📊 क्षेत्रफळ चार्ट - धोका पातळी दर्शक</h3>
//         {chartData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={300}>
//             <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="timeFormatted" tick={{ fontSize: 12 }} />
//               <YAxis label={{ value: "पातळी (मीटर)", angle: -90, position: "insideLeft" }} />
              
//               <Tooltip content={<CustomTooltip />} />
//               <Legend />
              
//               <Area
//                 type="monotone"
//                 dataKey="level"
//                 stroke="#2563eb"
//                 fill="url(#colorGradient)"
//                 strokeWidth={2}
//                 name="पाण्याची पातळी"
//               />
              
//               <defs>
//                 <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="5%" stopColor="#2563eb" stopOpacity={0.8}/>
//                   <stop offset="95%" stopColor="#2563eb" stopOpacity={0.1}/>
//                 </linearGradient>
//               </defs>
//             </AreaChart>
//           </ResponsiveContainer>
//         ) : (
//           <div className="text-center text-gray-500 py-8">
//             कोणताही डेटा उपलब्ध नाही
//           </div>
//         )}
//       </div>

//       {/* Data Table */}
//       <div className="bg-white rounded-lg shadow-md overflow-hidden">
//         <div className="p-4 bg-gray-50 border-b">
//           <h3 className="text-lg font-semibold">📋 सविस्तर डेटा टेबल</h3>
//         </div>
//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="border px-4 py-2 text-left">📍 स्थान</th>
//                 <th className="border px-4 py-2 text-left">📈 पातळी (मी.)</th>
//                 <th className="border px-4 py-2 text-left">🚨 धोका पातळी</th>
//                 <th className="border px-4 py-2 text-left">💧 प्रवाह</th>
//                 <th className="border px-4 py-2 text-left">📊 आकारमान</th>
//                 <th className="border px-4 py-2 text-left">🕒 वेळ</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData.map((row, idx) => {
//                 const floodInfo = getFloodLevel(row.level);
//                 return (
//                   <tr key={idx} className="hover:bg-gray-50">
//                     <td className="border px-4 py-2">{row.location}</td>
//                     <td className="border px-4 py-2 font-bold text-blue-600">
//                       {row.level}
//                     </td>
//                     <td className="border px-4 py-2">
//                       <span 
//                         className="px-2 py-1 rounded text-xs font-medium text-white"
//                         style={{ backgroundColor: floodInfo.color }}
//                       >
//                         {floodInfo.label}
//                       </span>
//                     </td>
//                     <td className="border px-4 py-2">{row.discharge}</td>
//                     <td className="border px-4 py-2">{row.volume}</td>
//                     <td className="border px-4 py-2 text-sm">
//                       {new Date(row.time).toLocaleString('hi-IN')}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Summary Statistics */}
//       <div className="mt-6 bg-white p-4 rounded-lg shadow-md">
//         <h3 className="text-lg font-semibold mb-3">📊 सांख्यिकी सारांश</h3>
//         <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-center">
//           <div className="bg-blue-50 p-3 rounded">
//             <div className="text-2xl font-bold text-blue-600">{data.length}</div>
//             <div className="text-sm text-gray-600">एकूण रीडिंग</div>
//           </div>
//           <div className="bg-yellow-50 p-3 rounded">
//             <div className="text-2xl font-bold text-yellow-600">{locationList.length}</div>
//             <div className="text-sm text-gray-600">निरीक्षण स्थाने</div>
//           </div>
//           <div className="bg-red-50 p-3 rounded">
//             <div className="text-2xl font-bold text-red-600">
//               {data.filter(d => getFloodLevel(d.level).color === '#ef4444' || getFloodLevel(d.level).color === '#991b1b').length}
//             </div>
//             <div className="text-sm text-gray-600">धोकादायक रीडिंग</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WaterLevelMonitoring;


import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  Area,
  AreaChart,
} from "recharts";

const GOOGLE_SHEET_ID = "1gXp7KngcraVZXc2T15hSTijyK2TJplWU5mDC2IZcxgE";
const SHEET_URL = `https://opensheet.elk.sh/${GOOGLE_SHEET_ID}/Sheet1`;

const FLOOD_LEVELS = {
  SAFE: { max: 50, color: "#22c55e", label: "सुरक्षित स्तर" },
  CAUTION: { max: 100, color: "#eab308", label: "सावधान स्तर" },
  WARNING: { max: 200, color: "#f97316", label: "चेतावणी स्तर" },
  DANGER: { max: 500, color: "#ef4444", label: "धोकादायक स्तर" },
  CRITICAL: { max: Infinity, color: "#991b1b", label: "अत्यंत धोकादायक" },
};

const WaterLevelMonitoring = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(SHEET_URL)
      .then((res) => res.json())
      .then((raw) => {
        const parsed = raw
          .filter((row) => row["device_id"] && row["Water level"])
          .map((row, index) => ({
            id: index,
            deviceId: row["device_id"] || "Unknown",
            location: row["location"] || "Unknown",
            level: parseFloat(row["Water level"] || 0),
            time: row["time"] || "",
            discharge: parseFloat(row["discharge"] || 0),
            volume: parseFloat(row["volume"] || 0),
            latitude: parseFloat(row["latitude"] || 0),
            longitude: parseFloat(row["longitude"] || 0),
          }))
          .sort((a, b) => new Date(a.time) - new Date(b.time));

        setData(parsed);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error loading sheet:", err);
        setLoading(false);
      });
  }, []);

  const getFloodLevel = (level) => {
    if (level <= FLOOD_LEVELS.SAFE.max) return FLOOD_LEVELS.SAFE;
    if (level <= FLOOD_LEVELS.CAUTION.max) return FLOOD_LEVELS.CAUTION;
    if (level <= FLOOD_LEVELS.WARNING.max) return FLOOD_LEVELS.WARNING;
    if (level <= FLOOD_LEVELS.DANGER.max) return FLOOD_LEVELS.DANGER;
    return FLOOD_LEVELS.CRITICAL;
  };

  const locationList = [...new Set(data.map((row) => row.location))];
  const filteredData = selectedLocation
    ? data.filter((row) => row.location === selectedLocation)
    : data;

  const chartData = filteredData.map((item) => ({
    ...item,
    floodLevel: getFloodLevel(item.level).label,
    timeFormatted: new Date(item.time).toLocaleString("hi-IN", {
      dateStyle: "short",
      timeStyle: "short",
    }),
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const floodInfo = getFloodLevel(data.level);

      return (
        <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-xl text-sm animate-fade-in">
          <p className="font-semibold text-gray-700">{`समय: ${data.timeFormatted}`}</p>
          <p className="text-blue-600 font-medium">{`पातळी: ${data.level} मीटर`}</p>
          <p className="text-gray-500">{`स्थान: ${data.location}`}</p>
          <p style={{ color: floodInfo.color }} className="font-semibold mt-1">
            {`स्तर: ${floodInfo.label}`}
          </p>
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-700 animate-pulse">
          डेटा लोड हो रहा है... ⏳
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gradient-to-r from-blue-50 via-white to-green-50 min-h-screen">
      <h1 className="text-4xl font-extrabold mb-8 text-center text-blue-800 drop-shadow-md">
        💧 पाण्याची पातळी मॉनिटरिंग सिस्टीम
      </h1>

      {/* Filters */}
      <div className="bg-white p-5 rounded-xl shadow-md mb-6 border border-gray-100 hover:shadow-lg transition-shadow">
        <label className="block font-semibold mb-2 text-gray-700">📍 स्थान निवडा:</label>
        <select
          value={selectedLocation || ""}
          onChange={(e) => setSelectedLocation(e.target.value || null)}
          className="w-full border border-gray-300 p-2 rounded-md shadow-sm focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all"
        >
          <option value="">-- सर्व स्थाने --</option>
          {locationList.map((location) => (
            <option key={location} value={location}>
              {location}
            </option>
          ))}
        </select>
      </div>

      {/* Flood Level Legend */}
      <div className="bg-white p-5 rounded-xl shadow-md mb-6 border border-gray-100 hover:shadow-lg transition-shadow">
        <h3 className="text-lg font-semibold mb-3 text-gray-700">🚨 पूर नियंत्रण स्तर</h3>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {Object.values(FLOOD_LEVELS).map((level, idx) => (
            <div
              key={idx}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-50 transition-all"
            >
              <div
                className="w-5 h-5 rounded-full border"
                style={{ backgroundColor: level.color }}
              ></div>
              <span className="text-sm font-medium text-gray-700">{level.label}</span>
              {level.max !== Infinity && (
                <span className="text-xs text-gray-400">(≤{level.max}m)</span>
              )}
              {level.max === Infinity && (
                <span className="text-xs text-gray-400">(>500m)</span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Line Chart */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-6 border border-gray-100 hover:shadow-lg transition-shadow">
        <h3 className="text-xl font-semibold mb-4 text-gray-700">📈 पाण्याची पातळी ट्रेंड</h3>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis dataKey="timeFormatted" tick={{ fontSize: 12 }} interval="preserveStartEnd" />
              <YAxis label={{ value: "पातळी (मीटर)", angle: -90, position: "insideLeft" }} />
              {Object.values(FLOOD_LEVELS).map((level, idx) =>
                level.max !== Infinity ? (
                  <ReferenceLine key={idx} y={level.max} stroke={level.color} strokeDasharray="5 5" />
                ) : null
              )}
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Line
                type="monotone"
                dataKey="level"
                stroke="#2563eb"
                strokeWidth={3}
                dot={{ fill: "#2563eb", strokeWidth: 2, r: 4 }}
                name="पाण्याची पातळी (मीटर)"
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="text-center text-gray-400 py-8">कोणताही डेटा उपलब्ध नाही</div>
        )}
      </div>

      {/* Area Chart */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-6 border border-gray-100 hover:shadow-lg transition-shadow">
        <h3 className="text-xl font-semibold mb-4 text-gray-700">📊 क्षेत्रफळ चार्ट - धोका पातळी दर्शक</h3>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis dataKey="timeFormatted" tick={{ fontSize: 12 }} />
              <YAxis label={{ value: "पातळी (मीटर)", angle: -90, position: "insideLeft" }} />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <defs>
                <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#2563eb" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#2563eb" stopOpacity={0.1} />
                </linearGradient>
              </defs>
              <Area type="monotone" dataKey="level" stroke="#2563eb" fill="url(#colorGradient)" strokeWidth={2} name="पाण्याची पातळी" />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <div className="text-center text-gray-400 py-8">कोणताही डेटा उपलब्ध नाही</div>
        )}
      </div>

      {/* Data Table */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow mb-6">
        <div className="p-4 bg-gray-50 border-b">
          <h3 className="text-lg font-semibold text-gray-700">📋 सविस्तर डेटा टेबल</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-4 py-2 text-left">📍 स्थान</th>
                <th className="border px-4 py-2 text-left">📈 पातळी (मी.)</th>
                <th className="border px-4 py-2 text-left">🚨 धोका पातळी</th>
                <th className="border px-4 py-2 text-left">💧 प्रवाह</th>
                <th className="border px-4 py-2 text-left">📊 आकारमान</th>
                <th className="border px-4 py-2 text-left">🕒 वेळ</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, idx) => {
                const floodInfo = getFloodLevel(row.level);
                return (
                  <tr key={idx} className="hover:bg-gray-50 transition-colors">
                    <td className="border px-4 py-2">{row.location}</td>
                    <td className="border px-4 py-2 font-bold text-blue-600">{row.level}</td>
                    <td className="border px-4 py-2">
                      <span
                        className="px-2 py-1 rounded text-xs font-medium text-white"
                        style={{ backgroundColor: floodInfo.color }}
                      >
                        {floodInfo.label}
                      </span>
                    </td>
                    <td className="border px-4 py-2">{row.discharge}</td>
                    <td className="border px-4 py-2">{row.volume}</td>
                    <td className="border px-4 py-2 text-sm">{new Date(row.time).toLocaleString("hi-IN")}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Summary Statistics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow text-center">
          <div className="text-3xl font-bold text-blue-600">{data.length}</div>
          <div className="text-gray-500 mt-1">एकूण रीडिंग</div>
        </div>
        <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow text-center">
          <div className="text-3xl font-bold text-yellow-600">{locationList.length}</div>
          <div className="text-gray-500 mt-1">निरीक्षण स्थाने</div>
        </div>
        <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow text-center">
          <div className="text-3xl font-bold text-red-600">
            {data.filter(
              (d) =>
                getFloodLevel(d.level).color === "#ef4444" ||
                getFloodLevel(d.level).color === "#991b1b"
            ).length}
          </div>
          <div className="text-gray-500 mt-1">धोकादायक रीडिंग</div>
        </div>
      </div>
    </div>
  );
};

export default WaterLevelMonitoring;
